import {capitalize} from "@pg-mono/nodash";

import {TabsActiveColor} from "../types/TabsActiveColor";

export const colorToClassName = (color: TabsActiveColor): string => {
    return color.split("-").map(capitalize).join("");
};
import {capitalize} from "@pg-mono/nodash";

import {TabsActiveColor} from "../types/TabsActiveColor";

export const colorToClassName = (color: TabsActiveColor): string => {
    return color.split("-").map(capitalize).join("");
};
